import type { Candidate } from "@/types";

export function scoreColor(score: number): string {
  if (score >= 80) return "text-emerald-600";
  if (score >= 60) return "text-lime-600";
  if (score >= 40) return "text-yellow-500";
  if (score >= 20) return "text-orange-500";
  return "text-[#ff0000]";
}

export function barColor(score: number): string {
  if (score >= 80) return "#059669";
  if (score >= 60) return "#65a30d";
  if (score >= 40) return "#eab308";
  if (score >= 20) return "#f97316";
  return "#ff0000";
}

export const recStyles: Record<Candidate["recommendation"], string> = {
  strong_hire: "bg-emerald-100 text-emerald-800",
  consider: "bg-amber-100 text-amber-800",
  reject: "bg-rose-100 text-error-text",
};

export const recLabel: Record<Candidate["recommendation"], string> = {
  strong_hire: "Strong hire",
  consider: "Consider",
  reject: "Reject",
};

export const ringColor: Record<Candidate["recommendation"], string> = {
  strong_hire: "#059669",
  consider: "#d97706",
  reject: "#e11d48",
};
